import { Link, useNavigate } from "react-router-dom";
import "./register.scss";
import { useState } from "react";
import { makeRequest } from "../../axios";

const Register = () => {
  const navigate = useNavigate()
  const [inputs, setInputs] = useState({
    username:"",
    email:"",
    password:"",
    name:"",
  });

  const [err, setErr] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = e => {
    setInputs((prev)=>({...prev, [e.target.name]:e.target.value}))
  };

  const handleClick = async e => {
    e.preventDefault();
    setErr(null)
    setSuccess(null)

    try {
      let res = await makeRequest.post("/auth/register", inputs);
      setSuccess(res.data);
      navigate("/login");
    } catch (err) {
      setErr(err.response.data)
    }
  }

  return (
    <div className="register">
      <div className="card">
        <div className="left">
          <h1>Social App</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero cum,
            alias totam numquam ipsa exercitationem dignissimos, error nam,
            consequatur.
          </p>
          <span>Do you have an account?</span>
          <Link to="/login">
            <button>Login</button>
          </Link>
        </div>
        <div className="right">
          <h1>Register</h1>
          <form>
            <input 
              type="text" 
              placeholder="Username" 
              name="username"
              onChange={handleChange} 
            />
            <input 
              type="email" 
              placeholder="Email" 
              name="email"
              onChange={handleChange} 
            />
            <input 
              type="password" 
              placeholder="Password" 
              name="password" 
              minLength="6"
              onChange={handleChange} 
            />
            <input 
              type="text" 
              placeholder="Name" 
              name="name"
              onChange={handleChange}
            />
            {err && err}
            {success && success}
            <button onClick={handleClick} type="submit">Create Account</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Register
